import React from "react";
import { LicitacoesPage } from "./licitacoes.page";
import { LicitacoesProvider } from "./context/licitacoes-context";

export function LicitacoesFactory() {
    return (
        <LicitacoesProvider>
            <LicitacoesPage></LicitacoesPage>
        </LicitacoesProvider>
    );
}
